
  // Export
  module.exports =
  {

    // Controller-wide scripts
    _init: function (controller, action)
    {

      // Activate the navigation item
      if (0 === $('.js-nav_item.active', '#navigation, #menu').length)
      {

        // Iterate over the menu items
        $('.js-nav_item', '#navigation, #menu').each(function ()
        {

          // If it matches
          if (String(controller).match(new RegExp('^' + $(this).data(APPLICATION._DATA_PREFIX + 'controller') + '$')))
          {

            // Get the pattern
            var pattern = $(this).data(APPLICATION._DATA_PREFIX + 'action')

            // If matches action
            if (undefined === pattern || String(action).match(new RegExp('^' + pattern + '$')))
            {

              // Make active
              $(this).addClass('active')

              // If menu
              if (0 !== $(this).closest('#menu').length)
              {

                // Add marker
                $(this).prepend('<span class="active-nav-marker"></span>')

                // Open parent
                $(this).closest('.collapse').collapse('show').prev().not('.active').addClass('active').prepend('<span class="active-nav-marker"></span>')

              }

            }

          }

        }
        )

      }

      // On clicking links
      $('[href]').not('.js-link-ignore').click(function (e)
      {

        // Continue as normal if opening in new a tab or window
        if (e.ctrlKey || e.shiftKey || e.metaKey || (e.button && 1 === e.button))
        {
          return
        }

        // Get the href
        var href = $(this).attr('href')

        // If checking session
        if ('javascript:' !== href && 0 !== href.indexOf('#') && !$(this).is('.do-not-check-session'))
        {

          // Check the session
          APPLICATION._APPLICATION.checkSession(function (href)
          {
            document.location.href = href
          }
          , [href])

          // Return false
          return false

        }

      }
      ).addClass('js-link-ignore')

      // On clicking the sidebar toggle
      $('#sidebar-toggle, #overlay').not('.js-ignore').click(function ()
      {
        $('#wrapper').toggleClass('menu')
      }
      ).addClass('js-ignore')

      // On submit
      $('[type=submit]').not('.js-ignore').click(function ()
      {

        // The button
        var button = $(this)

        // Set the call back
        var callback = function (button)
        {

          // Disable
          button.prop('disabled', true)

          // Submit form
          button.closest('form').submit()

        }

        // If do not check session
        if (button.is('.do-not-check-session'))
        {
          callback(button)
        }

        // Otherwise
        else
        {

          // Check the session
          APPLICATION._APPLICATION.checkSession(callback, [button])

          // Return false
          return false

        }

      }
      ).addClass('js-ignore')

      // On search
      $('.js-search').not('.js-ignore').keypress(function (e)
      {

        // If not enter
        if (13 !== e.keyCode)
        {
          return
        }

        // Prevent default
        e.preventDefault()

        // Search
        APPLICATION._APPLICATION.search($(this).closest('.js-url'))

      }
      ).addClass('js-ignore')

      // On refresh
      $('.js-refresh').click(function ()
      {
        APPLICATION._APPLICATION.search($(this).blur().closest('.js-url'))
      }
      ).removeClass('js-refresh')

      // On clear
      $('.js-clear').click(function ()
      {

        // Get the form
        var form = $(this).closest('form')

        // Reset the value
        $('.js-input, .dropdown-toggle', form).val('')

        // Uncheck any boxes
        $(':checked', form).prop('checked', false)

        // Remove any dropdown selection
        $('.input-dropdown li.active', form).removeClass('active')

        // Select default dropdown
        $('.input-dropdown li > a[data-' + APPLICATION._DATA_PREFIX + 'value="0"]', form).trigger('click')

      }
      ).removeClass('js-clear')

      // On saving
      $('.js-submit', '#modal').not('.js-ignore').click(function ()
      {

        // Change the opacity
        $('#modal-box > div').prepend('<div class="overlay"><div class="spinner-outer"><span class="fa fa-spinner fa-spin spinner"></span></div></div>')

        // Get the modal
        var modal = $('#modal')

        // Get the path
        var path = modal.data(APPLICATION._DATA_PREFIX + 'modal')

        // Get the controller
        var controller = modal.data(APPLICATION._DATA_PREFIX + 'controller')

        // Get the action
        var action = modal.data(APPLICATION._DATA_PREFIX + 'action')

        // Get the form
        var form = new FormData($('form', modal)[0])

        // The callback
        var callback = function (path, controller, action, form)
        {

          // Show modal
          $('body').addClass('show-modal')

          // Post the form
          $.ajax(
          {
            url: path,
            type: 'POST',
            data: form,
            contentType: false,
            processData: false,
            success: function (data)
            {

              // Load the content
              $('#modal-box > div', modal).html(data)

              // Scroll to the top
              window.scroll(0, 0)

              // On keydown
              $('input', '#modal').keydown(function (e)
              {

                // If enter
                if (13 === e.keyCode)
                {

                  // Prevent default
                  e.preventDefault()

                  // Click submit
                  $('.js-submit', '#modal').trigger('click')

                }

              }
              )

              // Re-run the application
              APPLICATION._init(controller, action)

            }

          }
          )

        }

        // If not checking session
        if (modal.is('.do-not-check-session'))
        {
          callback(path, controller, action, form)
        }

        // Otherwise
        else
        {
          APPLICATION._APPLICATION.checkSession(callback, [path, controller, action, form])
        }

      }
      ).addClass('js-ignore')

      // On closing a modal
      $('.js-close').click(function ()
      {

        // Hide modal
        $('body').removeClass('show-modal')

        // Scroll to the top
        // window.scroll(0, 0)
        // If you want to bring this back in, backend only.

      }
      ).removeClass('js-close')

      // On closing a modal
      $('#modal-container').not('.js-ignore').click(function (e)
      {

        // If not a child
        if (this === e.target)
        {

          // Hide modal
          $('body').removeClass('show-modal')

          // Scroll to the top
          window.scroll(0, 0)

        }

      }
      ).addClass('js-ignore')

      // Iterate over each modal
      $('.js-modal').click(function (e)
      {

        // Stop propagation
        e.stopPropagation()

        // Get the modal
        var modal = $('#modal')

        // Store the path
        var path = $(this).data(APPLICATION._DATA_PREFIX + 'modal')

        // Store the controller
        var controller = $(this).data(APPLICATION._DATA_PREFIX + 'controller')

        // Store the action
        var action = $(this).data(APPLICATION._DATA_PREFIX + 'action')

        // The callback
        var callback = function (path, controller, action)
        {

          // Store the content
          modal.data(APPLICATION._DATA_PREFIX + 'modal', path)

          // Store the controller
          modal.data(APPLICATION._DATA_PREFIX + 'controller', controller)

          // Store the action
          modal.data(APPLICATION._DATA_PREFIX + 'action', action)

          // Load the content
          $('#modal-box > div', modal).load(path, function ()
          {

            // On keydown
            $('input', '#modal').keydown(function (e)
            {

              // If enter
              if (13 === e.keyCode)
              {

                // Prevent default
                e.preventDefault()

                // Click submit
                $('.js-submit', '#modal').trigger('click')

              }

            }
            )

            // Show the modal
            $('body').addClass('show-modal')

            // Re-run the application
            APPLICATION._init(controller, action)

          }
          )

        }

        // If not checking session
        if ($(this).is('.do-not-check-session'))
        {

          // Do not check the modal submit for session
          modal.addClass('do-not-check-session')

          // Run the callback
          callback(path, controller, action)

        }

        // Otherwise
        else
        {

          // Check the modal submit for session
          modal.removeClass('do-not-check-session')

          // Check the session
          APPLICATION._APPLICATION.checkSession(callback, [path, controller, action])

        }

      }
      ).removeClass('js-modal')

      // Get the input dropdowns
      $('.input-dropdown').not('.js-ignore').each(function ()
      {
        APPLICATION._APPLICATION.dropdown($(this))
      }
      ).addClass('js-ignore')

      // Get the popovers
      APPLICATION._APPLICATION.popover($('.js-popover'))

      // Get the tooltip
      APPLICATION._APPLICATION.tooltip($('.js-tooltip'))

    },

    popover: function (popover)
    {

      // Create the popover
      popover.popover({html: true}).removeClass('js-popover')

    },

    tooltip: function (tooltip)
    {
      tooltip.tooltip().removeClass('js-popover')
    },

    // Search
    search: function (form)
    {

      // Remove any success message
      $('#success').remove()

      // Get the target
      var target = form.data(APPLICATION._DATA_PREFIX + 'target')

      // Add opacity
      $(target).css('opacity', 0.5)

      // Check the session
      APPLICATION._APPLICATION.checkSession(function ()
      {

        // Post the form
        $.post(form.data(APPLICATION._DATA_PREFIX + 'url'), form.serialize(), function (content)
        {

          // Add the results
          $(target).html(content)

          // Re-run the application
          APPLICATION._init(form.data(APPLICATION._DATA_PREFIX + 'controller'), form.data(APPLICATION._DATA_PREFIX + 'action'))

          // Remove opacity
          $(target).css('opacity', '')

        }
        )

      }
      )

    },

    // Manually fire modal
    fireModal: function(path, controller, action) {

      // Get the modal
      var modal = $('#modal')

      // Store the content
      modal.data(APPLICATION._DATA_PREFIX + 'modal', path)

      // Store the controller
      modal.data(APPLICATION._DATA_PREFIX + 'controller', controller)

      // Store the action
      modal.data(APPLICATION._DATA_PREFIX + 'action', action)

      // Load the content
      $('#modal-box > div', modal).load(path, function ()
      {

        // On keydown
        $('input', '#modal').keydown(function (e)
        {

          // If enter
          if (13 === e.keyCode)
          {

            // Prevent default
            e.preventDefault()

            // Click submit
            $('.js-submit', '#modal').trigger('click')

          }

        }
        )

        // Show the modal
        $('body').addClass('show-modal')

        // Re-run the application
        APPLICATION._init(controller, action)

      }
      )

    },

    // Process the links
    processLinks: function (context, controller, action)
    {

      // On clicking the links
      $('.js-href', context).click(function ()
      {
        console.log(context)
        APPLICATION._APPLICATION.load($(context), $(this).attr('data-' + APPLICATION._DATA_PREFIX + 'href'), controller, action)
      }
      ).removeClass('js-href')

    },

    // Check the session
    checkSession: function (callback, args)
    {

      // If not signed in
      if ($('body').is('.not-signed-in'))
      {
        callback.apply(null, args || [])
      }

      // Otherwise
      else
      {

        // Check the session
        $.ajax(APPLICATION._PATH_PREFIX + 'session_check.php',
        {

          // On success
          success: function (data)
          {

            // Re-sign in if not successful
            if ('1' !== data)
            {

              // Store the callback
              APPLICATION.Account.reSignIn.args = args || []

              // Store the callback
              APPLICATION.Account.reSignIn.callback = callback

              // Re-sign in
              $('#re-sign-in').trigger('click')

            }

            // Otherwise load the page
            else
            {
              callback.apply(null, args || [])
            }

          }

        }
        )

      }

    },

    // Load
    load: function (target, url, controller, action, callback)
    {

      // Check the session
      APPLICATION._APPLICATION.checkSession(function ()
      {

        // Set the opacity
        target.css('opacity', 0.5)

        // Load
        target.load(url, function ()
        {

          // Initialize the application
          APPLICATION._init(controller, action)

          // Reset the opacity
          target.css('opacity', '')

          // Run any callback
          if ('function' === typeof callback)
          {
            callback()
          }

        }
        )

      }
      )

    },

    // Dropdown
    dropdown: function (dropdown)
    {

      // On clicking option
      $('.dropdown-menu > li > a', dropdown).not('.js-ignore, .js-disabled').click(function ()
      {

        // Remove any active
        $('.dropdown-menu > li.active', dropdown).removeClass('active')

        // Mark this as active
        $(this).parent().addClass('active')

        // Set the value
        $('.js-input', dropdown).val($(this).data(APPLICATION._DATA_PREFIX + 'value')).trigger('change')

        // Set the text
        $('.dropdown-toggle', dropdown).val($(this).text())

      }
      )

      // Trigger any active
      $('.dropdown-menu > li.active > a', dropdown).not('.js-ignore').trigger('click')

      // On clicking option
      $('.dropdown-menu > li > a', dropdown).not('.js-ignore').addClass('js-ignore')

    },

    // Add row
    addRow: function (row)
    {

      // Get the rows
      var rows = $('.rows[data-' + APPLICATION._DATA_PREFIX + 'row_group="' + row.data( APPLICATION._DATA_PREFIX + 'row_group')  + '"]')

      // Clone the row
      var clone = row.clone()

      // Remove any feedback
      clone.removeClass('has-error has-success')

      // Remove any feedback
      $('.form-group', clone).removeClass('has-error has-success')

      // Remove any elements
      $('.js-row-remove', clone).remove()

      // Reset the value
      $('.js-input, .dropdown-toggle', clone).val('')

      // Uncheck any boxes
      $(':checked', clone).prop('checked', false)

      // Remove any dropdown selection
      $('.input-dropdown li.active', clone).removeClass('active')

      // Remove any ignore classes
      $('.js-ignore', clone).removeClass('js-ignore')

      // Get the input dropdowns
      $('.input-dropdown', clone).each(function ()
      {
        APPLICATION._APPLICATION.dropdown($(this))
      }
      ).addClass('js-ignore')

      // Add the clone to the rows
      row.after(clone)

      // Return the clone
      return clone

    },

    // Remove row
    removeRow: function (row)
    {

      // Get the group
      var group = row.data(APPLICATION._DATA_PREFIX + 'row_group')

      // Get the rows
      var rows = $('.rows[data-' + APPLICATION._DATA_PREFIX + 'row_group="' + group  + '"]')

      // If only one
      if (1 == $('.row-item[data-' + APPLICATION._DATA_PREFIX + 'row_group="' + group  + '"]', rows).length)
      {
        this.addRow(row)
      }

      // Remove the row
      row.remove()

    },

  }